import React from 'react';
import PropTypes from 'prop-types';
import { InputAdornment, TextField } from '@material-ui/core';
import { SearchIcon } from '@svgComponents/index';
import { t } from 'ttag';


/**
 * A search input field component with a search icon adornment.
 *
 * @param {Object} props - The component props
 * @param {string} [props.placeholder] - Placeholder text for the search field. Defaults to a localized "Type to search..." message
 * @param {Function} [props.onChange] - Callback function invoked when the search field value changes. Receives the new value as a string parameter
 *
 * @returns {JSX.Element} A TextField component configured as a search field with event handlers to prevent event propagation
 *
 * @example
 * <SearchField
 *   placeholder="Search products..."
 *   onChange={(value) => console.log(value)}
 * />
 */
const SearchField = ({ placeholder = t`Type to search...`, onChange }) => {
  const inputProps = {
    endAdornment: (
      <InputAdornment position="start">
        <SearchIcon style={{ fill: '#aaa2aa' }} />
      </InputAdornment>
    ),
  };

  const handleSearchFieldChange = (event) => {
    onChange?.(event.target.value);
  };

  const handleSearchFieldClick = (event) => {
    event.stopPropagation();
  };

  const handleSearchFieldKeyDown = (event) => {
    event.stopPropagation();
  };

  return (
    <TextField
      size="small"
      variant="outlined"
      autoFocus
      placeholder={placeholder}
      fullWidth
      InputProps={inputProps}
      onChange={handleSearchFieldChange}
      onClick={handleSearchFieldClick}
      onKeyDown={handleSearchFieldKeyDown}
    />
  );
};

SearchField.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

export default SearchField;
